import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import muzukuruLogo from "../../assets/muzukurublack.png";

const pageLabels: Record<string, string> = {
  "/review": "Reviews",
  "/pricing": "Pricing",
  "/resources": "Resources",
  "/business": "Business",
  "/contact": "Contact",
  "/death-notices": "Death Notices",
  "/post-funeral": "Post a Funeral",
  "/socials": "Socials",
};

const ComingSoonPage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pageLabel = pageLabels[pathname] ?? "This Page";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: "24px",
        background: `
          radial-gradient(ellipse 120% 60% at 50% 100%, rgba(203,135,80,0.20) 0%, transparent 65%),
          #ffffff
        `,
        textAlign: "center",
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src={muzukuruLogo}
        alt="Muzukuru"
        sx={{ height: "36px", objectFit: "contain", mb: "48px", opacity: 0.85 }}
      />

      {/* Under construction icon */}
      <Box
        sx={{
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          bgcolor: "#FDF2E9",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: "32px",
          fontSize: "36px",
        }}
      >
        🚧
      </Box>

      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 800,
          fontSize: { xs: "32px", md: "48px" },
          color: "#111111",
          letterSpacing: "-0.035em",
          lineHeight: 1.15,
          mb: "16px",
        }}
      >
        {pageLabel} — Coming Soon
      </Typography>

      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 400,
          fontSize: { xs: "15px", md: "17px" },
          color: "#737373",
          lineHeight: 1.7,
          maxWidth: "480px",
          mb: "40px",
        }}
      >
        We&apos;re working hard to bring this page to life. Check back soon —
        something great is on its way.
      </Typography>

      <Button
        onClick={() => navigate("/")}
        sx={{
          fontFamily: "Mulish",
          fontWeight: 700,
          fontSize: "15px",
          textTransform: "none",
          bgcolor: "#614438",
          color: "#fff",
          px: "28px",
          py: "12px",
          borderRadius: "999px",
          "&:hover": { bgcolor: "#4e342e" },
        }}
      >
        Back to Home
      </Button>
    </Box>
  );
};

export default ComingSoonPage;
